<ion-content class="tracker-theme"
             #content
             scrollEvents="true"
             (ionScroll)="onContentScroll($event)">

  <div class="main-container fade-in">
    <!-- HEADER -->
    <div class="header-section">
      <div class="header-left">
        <div class="title-text">
          <h1 class="gradient-text">{{ termsTitle || 'Terms & Conditions' }}</h1>
          <p>Please read carefully to proceed</p>
        </div>
      </div>
      <div class="header-right">
        <div class="header-illustration terms-style">
          <div class="sparkle s1">✦</div>
          <div class="shield-emoji">🛡️</div>
        </div>
      </div>
    </div>

    <!-- TERMS BOX -->
    <div class="terms-box bento-card" #termsBox [innerHTML]="termsContent"></div>
  </div>

</ion-content>

<ion-footer class="ion-no-border tracker-theme">
  <div class="footer-inner">

    <!-- Visual indicator when scrolled to bottom -->
    <div class="scroll-hint-wrapper" *ngIf="!hasScrolledToBottom">
      <div class="scroll-hint-pill bounce">
        <ion-icon name="arrow-down-outline"></ion-icon>
        <span>Scroll down to agree</span>
      </div>
    </div>

    <!-- ACCEPT CHECKBOX -->
    <div class="accept-section">
      <ion-item lines="none" class="accept-item bento-card">
        <ion-checkbox
          slot="start"
          [(ngModel)]="isAccepted"
          [disabled]="!hasScrolledToBottom">
        </ion-checkbox>
        <ion-label class="ion-text-wrap ion-no-margin">
          I have read and agree to the
          <span class="terms-link" (click)="scrollToTop()">Terms & Conditions</span>
        </ion-label>
      </ion-item>
    </div>

    <div class="footer-buttons">
      <!-- <ion-col size="4">
        <ion-button
          fill="outline"
          color="primary"
          expand="block"
          (click)="submitAcceptance(0)">
          Decline
        </ion-button>
      </ion-col> -->

      <ion-button
        class="bento-submit-btn"
        expand="block"
        (click)="submitAcceptance(1)"
        [disabled]="!isAccepted || !hasScrolledToBottom">
        Accept & Continue
      </ion-button>
    </div>
  </div>
</ion-footer>
